<template>
  <div
    class="help-actions gw_box"
    style="--box-padding: 0"
  >
    <div class="gw_box gw_box_widget_title">
      {{ $t('common.resources') }}
      <div class="mr-auto"></div>
    </div>
    <div
      class="gw_box f-column"
      style="--box-padding: 1rem 0.5rem; gap: 0rem"
    >
      <component
        :is="item.component ? item.component : 'div'"
        v-for="(item, i) in helps"
        :key="i + 'help_item'"
        v-ripple
        class="gw_btn-v1 gw_btn_text clr-grey f-justify-start"
        style="--padding: 0 0.5rem"
        :style="item.style || ''"
        :class="item.cssClass || ''"
        v-bind="item.props || {}"
        @click="hadleHelpClick(item)"
      >
        <div
          class="mr-2 mdi text-semi-large"
          :class="item.icon"
        ></div>
        <span class="name">{{ item.name }}</span>
        <!-- <div
          v-if="item.new"
          class="gw_tag pa-1"
          style="background: var(--clr-primary); position: relative; top: 0; left: 0.5rem"
        >
          new
        </div> -->
      </component>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'DashboardSubLinks',
  mixins: [float_mix, format_mix, links_mix],
  methods: {
    hadleHelpClick(item) {
      if (item.fn) {
        item.fn()
      }
    },
    openRoadmap() {
      this.$store.dispatch('router_set_dialogs', 'roadmap-dialog')
    },
  },
  computed: {
    // TODO move to link mixin
    helps() {
      return [
        {
          name: this.links_all.FairPlay.title,
          props: { to: this.links_all.FairPlay.pathName },
          component: 'router-link',
          icon: this.links_all.FairPlay.icon,
        },
        {
          name: this.links_all.IcmCalculatorView.title,
          props: { to: this.links_all.IcmCalculatorView.pathName },
          component: 'router-link',
          icon: this.links_all.IcmCalculatorView.icon,
        },
        {
          icon: 'mdi-book-open-page-variant',
          g1_hide: true,
          name: this.$t('common.daily_dose_of_gto'),
          component: 'a',
          props: {
            href: 'https://dailydoseofgto.com/?utm_source=gtowizard&utm_medium=web&utm_campaign=dashboard',
            target: '_blank',
          },
        },
        {
          name: this.$t('dashboard.help.join_discord'),
          icon: 'mdi-discord',
          component: 'a',
          props: {
            href: this.links_url_links.discord_invite_link.url,
            target: '_blank',
          },
        },
        {
          name: this.$t('dashboard.help.see_roadmap'),
          icon: 'mdi-calendar-clock',
          fn: this.openRoadmap,
        },
        {
          icon: 'mdi-cube',
          g1_hide: true,
          name: this.$t('common.blog'),
          component: 'a',
          props: {
            href: 'https://blog.gtowizard.com/',
            target: '_blank',
          },
        },
        {
          g1_hide: true,
          icon: this.links_url_links.help_center.icon,
          name: this.links_url_links.help_center.text,
          component: 'a',
          props: {
            href: this.links_url_links.help_center.url,
            target: '_blank',
          },
        },
        {
          name: this.$t('links.pricing'),
          props: { to: '/subscription' },
          component: 'router-link',
          // icon: 'mdi-currency-usd',
          icon: 'mdi-crown',
          style: 'color:var(--clr-primary)!important; --borders:solid 1px var(--clr-primary)',
          cssClass: 'gw_btn_outlinse gw_btn_primary',
        },
      ].filter(i => !!i && (i.g1_hide ? !this.$i18n.g1 : !i.hide))
    },
  },
}
</script>
